import React, { Component } from "react";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import ScrollToView from "./../Components/Scroll/ScrollToView";
import Header from "./../Components/Header/Header";
import Footer from "./../Components/Footer/Footer";
import Loadable from "react-loadable";
import LoadingComponent from "./../Pages/Loading/Loading";
import ProfileProgramContribution from "./../Pages/Profile/ProfileProgramContribution";
import ProfileProgramContributionAdoption from "../Pages/Profile/ProfileProgramContributionAdoption";
import ProfileTreeDetailAdoption from "../Pages/Profile/ProfileTreeDetailAdoption";

const Home = Loadable({
   loader: () => import("./../Pages/Home/Home"),
   loading: LoadingComponent,
});
const Profile = Loadable({
   loader: () => import("./../Pages/Profile/Profile"),
   loading: LoadingComponent,
});
const ProfileTreeHistoryContribution = Loadable({
   loader: () => import("./../Pages/Profile/ProfileTreeHistoryContribution"),
   loading: LoadingComponent,
});
const ProfileTreeDetailHistory = Loadable({
   loader: () => import("../Pages/Profile/ProfileTreeDetailHistory"),
   loading: LoadingComponent,
});
const ProfileProgramSensor = Loadable({
   loader: () => import("../Pages/Profile/ProfileProgramSensor"),
   loading: LoadingComponent,
});
// const Unsubscribe = Loadable({
//    loader: () => import('../Pages/Unsubscribe/Unsubscribe'),
//    loading: LoadingComponent
// })
const LayoutHeader = ({ children }) => (
   <div>
      {children}
      <Footer />
   </div>
);

export class Layout extends Component {
   render() {
      return (
         <div className='wrapper'>
            <Router basename={process.env.PUBLIC_URL}>
               <ScrollToView>
                  <Switch>
                     <LayoutHeader>
                        <Route
                           path='/profile/:idprofile'
                           name='Profile'
                           component={Profile}
                           exact
                        />
                        <Route path='/' component={Home} exact />
                        <Route
                           path='/profile/:idprofile/:idprogram/program'
                           name='Profile Program Contribution'
                           component={ProfileProgramContribution}
                           exact
                        />

                        <Route
                           path='/profile/:idprofile/:idprogram/program-adoption'
                           name='Profile Program Contribution'
                           component={ProfileProgramContributionAdoption}
                           exact
                        />

                        <Route
                           path='/profile/:idprofile/:idprogram/sensor'
                           name='Profile Data Sensor Program'
                           component={ProfileProgramSensor}
                           exact
                        />
                        <Route
                           path='/profile/:idprofile/:idtreesummary/tree-history'
                           name='Profile Tree History'
                           component={ProfileTreeHistoryContribution}
                           exact
                        />
                        <Route
                           path='/profile/:idprofile/:idtreehistory/tree-adoption'
                           name='Profile Tree Adoption'
                           component={ProfileTreeDetailAdoption}
                           exact
                        />
                        <Route
                           path='/profile/:idprofile/:idtreesummary/:idhistory/detail-history'
                           name='Profile Tree History'
                           component={ProfileTreeDetailHistory}
                           exact
                        />
                     </LayoutHeader>
                  </Switch>
               </ScrollToView>
            </Router>
         </div>
      );
   }
}

export default Layout;
